module.exports = __webpack_public_path__ + "static/media/emotiveExampleFull.00b07ffa.jpg";